import React, { Component } from 'react'
import './CSS/T_C.css'
export class T_C extends Component {
  render() {
    return (
      <div>
      <br /><br /><br /><br />
            <div className='terms-and-condition'>
                <h1>Terms & Conditions for Zigara Logistics</h1>
            <span>User Terms</span>
            <p>
            These terms of use ("Terms of Use") mandate the terms on which users ("You" or "Your" or "Yourself" or "Users") interested in browsing or availing Zigara Logistics(defined below), and accessing the platform www.Zigaralogistics.ng  and the mobile application owned and operated Zigara ("Zigara") collectively referred to as, the "Platform" connects with the merchants registered on the Platform ("Tied-up Merchants"), merchants not registered on the Platform ("Non-tied up Merchants") (together hereinafter referred to as "Merchants") and with delivery partners ("Zigara") to avail the Zigara Services.
            
            Please read the Terms of Use carefully before using the Platform or registering on the Platform or accessing any material or information through the Platform. By clicking on the "I Accept" button, You accept this Terms of Use and agree to be legally bound by the same.
            
            Use of and access to the Platform is offered to You upon the condition of acceptance of all the terms, conditions and notices contained in this Terms of Use and Privacy Policy, along with any amendments made by zigara at its sole discretion and posted on the Platform from time to time.
            
            For the purposes of these Terms of Use, the term ‘Zigara' or 'Us' or 'We' refers to Zigara logistics. The term 'You' refers to the user or visitor of the Website and/or App. When You use our services, You will be subject to the terms, guidelines and policies applicable to such service and as set forth in these Terms of Use. As long as you comply with these Terms of Use, We grant You a personal, non-exclusive, non-transferable, limited privilege to enter and use our Platforms and services.
            
            ‍
            </p>
            </div>
      
      
      </div>
    )
  }
}

export default T_C